export const firebaseConfig = {
    apiKey: "AIzaSyBQ2VK53f8CUtIKYyiVg0misI5iQgXXktQ",
    authDomain: "ecfinder-7e8df.firebaseapp.com",
    databaseURL: "https://ecfinder-7e8df.firebaseio.com",
    projectId: "ecfinder-7e8df",
    storageBucket: "ecfinder-7e8df.appspot.com",
    messagingSenderId: "181195345499",
    appId: "1:181195345499:web:adcd90203f02fb8c7ab97e",
    measurementId: "G-DY5R9JKHTZ"
  };